import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconArrowLeft = createIcon({
  displayName: 'IconArrowLeft',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M1.59003 12L10.29 20.71L11.71 19.29L4.41003 12L11.71 4.71L10.29 3.29L1.59003 12ZM8.24002 13L7.24002 12L8.24002 11H22V13H8.24002Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
